import { useTranslation } from 'react-i18next';

const SECTION_KEYS = [
  'engagement',
  'payment',
  'personalData',
  'intellectualProperty',
  'earlyTermination'
];

export default function TermsContent({ className = '' }) {
  const { t } = useTranslation('common');

  return (
    <div className={`max-h-80 overflow-y-auto rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700 space-y-4 ${className}`}>
      {SECTION_KEYS.map((key) => (
        <div key={key}>
          <h4 className="font-semibold text-gray-900 mb-1">
            {t(`terms.sections.${key}.title`)}
          </h4>
          <p className="leading-relaxed">
            {t(`terms.sections.${key}.content`)}
          </p>
        </div>
      ))}
    </div>
  );
}
